$(document).ready(function () {
  //add to cart function
  function addToCart(id, qty) {
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        id: id,
        quantity: qty,
      },
      dataType: "json",
      success: function (response) {
        setTimeout (function(){
          $('cart-drawer').load(window.location.href + ' #CartDrawer');
          $('cart-drawer').removeClass('is-empty');
          openCartDrawer()
        }, 2000);
      },
      error: function (XMLHttpRequest, textStatus) {
      console.error("Error adding product to cart:", textStatus);
    },
    });
  }
function openCartDrawer() {
  document.querySelector('cart-drawer').classList.add('active');
}
  $(document).on("click", ".add-to-cart-btn", function () {
    var variantID = $(this).attr("product-variant_id");
    var variant_quantity = 1;
    addToCart(variantID, variant_quantity);
  });

  jQuery(".accordion-header").click(function () {
    jQuery(this).parent().children(".accordion-content").slideToggle();
    jQuery(this).parents(".accordion-item").toggleClass("pannel-active");
  });

  $(".product-bottom-slider").slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".best-selling-slider").slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".testimonial-slider").slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
  });
  if ($(window).width() <= 767) {
    $(".clinical-three-column-mid, .daily-essentails .product-card-wrapper").slick({
      infinite: true,
      slidesToShow: 1,
      arrows: true,
      dots: true,
      slidesToScroll: 1,
    });

    $(".heartFormula-column-mid").slick({
      infinite: true,
      slidesToShow: 1,
      arrows: false,
      dots: true,
      slidesToScroll: 1,
    });
  }
});


var counted = 0;
$(window).scroll(function () {
  var oTop = $("#counter").offset().top - window.innerHeight;
  if (counted == 0 && $(window).scrollTop() > oTop) {
    $(".count").each(function () {
      var $this = $(this),
        countTo = $this.attr("data-count");
      $({
        countNum: $this.text(),
      }).animate(
        {
          countNum: countTo,
        },
        {
          duration: 2000,
          easing: "swing",
          step: function () {
            $this.text(Math.floor(this.countNum));
          },
          complete: function () {
            $this.text(this.countNum);
          },
        }
      );
    });
    counted = 1;
  }
});
